






























































import { Component, Vue } from 'vue-property-decorator';
import freightEdit from './freightEdit.vue';
import freightLook from './freightLook.vue';
import { freightList, delOrderFreight} from "@/utils/api";
import { warning, success } from "@/utils/find";
@Component({
  components: {
    freightEdit,
    freightLook
  }
})
export default class freightOrder extends Vue {
  tableData: Array<object>=[];//列表数据
  currentPage: number=1;//当前页面
  total: number=20;//总条数
  loading: boolean=false;//加载
  freightTitle: string='新增订单运费模版';//抽屉title
  drawer: boolean=false;//抽屉是否打开
  drawerLook: boolean=false;
  orderData: object={};//订单数据
  created () {
    this.freightList(0);
  }
  // 列表
  freightList(page){
    this.loading=true;
    freightList({
      page:page,
      size:20
    }).then((data:any)=>{
      this.tableData=data.content;
      this.currentPage=data.number+1;
      this.total=data.totalElements;
    }).finally(()=>{
      this.loading=false;
    })
  }
  // 删除
  onConfirm(id){
    delOrderFreight({
      templateId:id
    }).then(res=>{
      success('删除成功');
      this.freightList(this.currentPage-1);
    })
  }
  // 修改查看订单
  edit(data,s){
    this.drawer=true;
    if(data.defaulted==0){
      this.freightTitle='修改订单运费模版（非内置）';//抽屉title
    }else{
      this.freightTitle='修改订单运费模版（内置）';//抽屉title
    }
    this.orderData={data,added:false};
  }
  // 查看
  look(data){
    if(data.defaulted==0){
      this.freightTitle='查看订单运费模版（非内置）';//抽屉title
    }else{
      this.freightTitle='查看订单运费模版（内置）';//抽屉title
    }
    this.drawerLook=true;
    this.orderData={data,added:false};
  }
  // 新增商品
  onSubmit(){
    this.drawer=true;
    this.orderData={added:true};
    this.freightTitle='新增订单运费模版';//抽屉title
  }
  // 跳转页面
  handleCurrentChange(val) {
    this.freightList(val-1);
  }
  // 关闭抽屉
  close(){
    this.drawer=false;
    this.freightList(this.currentPage-1);
  }
}
